import { FronteggExtensionsPermissionKeys } from './fronteggExtensionsKeys';

/**
 * Permission keys that extensions are allowed to request via the
 * `extension-token` capability. Acts as a strict allowlist: keys outside
 * this set cannot be delegated into a derivative token, even if a user
 * holds them. The mint intersects this list with the manifest's
 * declaration AND the user's role-granted permissions; only the
 * three-way intersection lands in the token's `scope.entitlements`
 * claim.
 *
 * Adding a new entry here is a deliberate act — it makes the entitlement
 * available for delegation to any extension whose manifest declares it.
 */
export const DELEGATABLE_ENTITLEMENTS: readonly FronteggExtensionsPermissionKeys[] =
  [
    FronteggExtensionsPermissionKeys.HotpotStashRead,
    FronteggExtensionsPermissionKeys.HotpotStashWrite,
    FronteggExtensionsPermissionKeys.HotpotJournalWrite,
    FronteggExtensionsPermissionKeys.HotpotMessagesRead,
    FronteggExtensionsPermissionKeys.HotpotVisitRead,
  ];

const DELEGATABLE_ENTITLEMENTS_SET: ReadonlySet<string> = new Set(
  DELEGATABLE_ENTITLEMENTS,
);

export const isDelegatableEntitlement = (
  s: string,
): s is FronteggExtensionsPermissionKeys => DELEGATABLE_ENTITLEMENTS_SET.has(s);
